import { FC, useMemo, useState } from 'react';
import { isArray, refactorPermissions } from '@lhb/func';
import styles from '../index.module.less';
import TitleOperate from './TitleOperate';

const targetBtnEvents = [ // 指定显示的按钮
  'spotSurvey:createChancePoint',
];

/**
 * @Description 踩点记录详情-顶部
 */
const Header: FC<{
  headerRef,
  detail?,
  /** 是否分享时 */
  isShare?,
  shareData?: any;
  standardChancePointAlias,
  setRefreshChanceFlag,
  isSjtb?: boolean;
}> = ({ headerRef, detail, isShare, standardChancePointAlias, setRefreshChanceFlag,
  isSjtb,
  shareData,
}) => {

  const [createChanceLoading, setCreateChanceLoading] = useState<boolean>(false);

  const operateList = useMemo(() => {
    const { permissions } = detail || {};
    const btns = isArray(permissions) ? permissions.filter(itm => targetBtnEvents.includes(itm.event)) : [];

    return refactorPermissions(btns).map((itm, idx) => {
      itm.type = (idx === btns.length - 1) ? 'primary' : 'default';
      if (itm.event === 'createChancePoint') {
        itm.disabled = createChanceLoading;
        itm.text = itm.text.replace('机会点', standardChancePointAlias);
        itm.name = itm.name.replace('机会点', standardChancePointAlias);
      }
      return itm;
    });
  }, [detail, createChanceLoading]);

  return (
    <div className={styles.header} ref={headerRef}>
      <div className={styles.headerTitle}>{isSjtb || !!shareData?.isSjtb ? '机会点' : '踩点记录'}详情</div>
      {!isShare && Array.isArray(operateList) && operateList.length > 0 &&
        <TitleOperate
          detail={detail}
          operateList={operateList}
          createChanceLoading={createChanceLoading}
          setCreateChanceLoading={setCreateChanceLoading}
          standardChancePointAlias={standardChancePointAlias}
          setRefreshChanceFlag={setRefreshChanceFlag}
        />}
    </div>
  );
};

export default Header;
